var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"app-extension"}},[_c('div',[_c('update-report'),_c('save-report-as'),_c('report-view-list'),_c('export-report',{on:{"on-export":_vm.onExport}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }